import { AndroidFromStrategyIcon } from '@/svgs'
import React from 'react'

function AndroidFromStrategy() {
   return (
      <section id="development-guide-section" className="cs-bg-theme-color-2">
         <div className="container">
            <p className="section_heading_title mb-3">
               From Concept to Deployment:
               <br />
               How We Develop Android Apps
            </p>

            <p className="section_desc">
               12+ years of experience in Android app development, we design
               scalable, secure, and high-performing mobile apps suited for your
               business requirements. Our seasoned team works with you to craft
               a strategic plan, ensuring trouble-free deployment and
               sustainable success. With our Android solutions, boost user
               experience, improve app performance, and lead the market. Let's
               create excellence together!
            </p>

            <AndroidFromStrategyIcon />
         </div>
      </section>
   )
}

export default AndroidFromStrategy
